import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { IPaymentResponse } from 'src/app/shared/models/core/payment.model';
import { IMemberCardDetails, IPaymentDetails } from '../../shared/models/core/member.model';
import { PaymentDetailsService } from '../../shared/services/member-details.service';
import { OnInit } from '@angular/core';
import { AppConfigService } from '../../shared/services/app-config.service';

@Component({
  selector: 'ben-card-renewal',
  templateUrl: './card-renewal.component.html',
  styleUrls: ['./card-renewal.component.scss']
})
export class CardRenewalComponent implements OnInit {
  public activeSectionIndex = 0;

  memberDetails!: IPaymentDetails;
  annualPrice!: string;
  getcarddetailssuccess= false;
  hidesagepaylinks = true;
  paymentComponent = true;
  iswas ="is";
  renewalDate: any
  cardstatus = {
    readyForRenewal: false,
    CardExpirePriorRenewal: false,
    InArrears: false
  }
  payment = {
    status: '',
    sagepaydown: false,
    ccAccountHolder: false,
    type: ''
  };
  application = {
    vendorTxCode: '',
    cardType: ''
  };
  NextURL: any;
  loading: boolean = true;
  paymentLoader: boolean = true;
  homeUrl: string;

  constructor(private PaymentDetailsService: PaymentDetailsService,              
              private sanitizer: DomSanitizer,
              private appConfigService: AppConfigService) { }

  ngOnInit() {
    this.loading = true;
    this.homeUrl = this.appConfigService.getLoadedConfig().communityUrl;
    this.getMemberDetails();
    this.paymentComponent = this.getPaymentContent();
  }

  getMemberDetails() {
    this.PaymentDetailsService.getMemberCardDetails().subscribe(
      (data: IMemberCardDetails) => {
        if (data) {
          if (data.CardDetails && data.CardDetails?.CardStatus == 'ACTIVE' && data.CardDetails?.CardPayerYN == 'Y' && parseFloat(data.Amount) > 0) {
            let paymentDetails: IPaymentDetails = { Success: true, Data: data };
            this.memberDetails = paymentDetails;
            this.getAnnualPrice();
            this.getDetailsSuccess();
            this.getRenewalDateDetails();
            this.loading = false;
          }
          else {
            window.location.href = this.homeUrl;
          }
        }

      }, (error) => {
        this.loading = false;
        window.location.href = this.homeUrl;
      });
  }

  getRenewalDate()
  {
    this.renewalDate = this.memberDetails.Data.CardDetails.RenewalDate;
  }

  getRenewalDateDetails(){
    if (this.memberDetails.Data.CardDetails.CardPayerYN) {
      this.renewalDate = new Date(this.memberDetails.Data.CardDetails.RenewalDate);
      var gracePeriodDate = new Date(this.memberDetails.Data.CardDetails.GracePeriodEndDate);

      var today = new Date();
      gracePeriodDate.setDate(gracePeriodDate.getDate());
      gracePeriodDate.setHours(23, 59, 59, 999);
      if (today > this.renewalDate && today < gracePeriodDate) {
        this.cardstatus.readyForRenewal = true;
      }

      if (this.memberDetails.Data.CardDetails.ExpiryAsDate != null) { // check in case not been created in json
          var expiryDate = new Date(this.memberDetails.Data.CardDetails.ExpiryAsDate);
          if (expiryDate < this.renewalDate) {
              this.cardstatus.CardExpirePriorRenewal = true;
          }
      }
      if (this.renewalDate < today.setHours(0, 0, 0, 0)) {
            this.iswas = 'was';
          }
      }
  }

  getAnnualPrice() {
    const outstandingAmount = this.memberDetails?.Data.Amount ?? 0;
    this.annualPrice = Math.abs(parseFloat(outstandingAmount)).toFixed(2).toString();
  }

  getDetailsSuccess() {
    const carddetailssuccess = this.memberDetails?.Success ?? false;
    this.getcarddetailssuccess = carddetailssuccess;
  }

  clickButton(){
    this.payment.status = "success"
  }

  ShowSagePayLink()
  {
    if (parseFloat(this.annualPrice) > 0) {
      this.hidesagepaylinks = false;
    }
  }
  public getPaymentContent(): boolean {
    return this.getcarddetailssuccess && this.payment.status !== 'success' && this.payment.status !== 'error' ? false:true;
  }
  
  getPaymentUrl(): void {
    this.payment.status = '';
    this.payment.sagepaydown = false;
    this.application.vendorTxCode = '';
    this.application.cardType = '';
    this.NextURL = this.sanitizer.bypassSecurityTrustResourceUrl('');
    this.paymentLoader = true;

    this.PaymentDetailsService.getTransactionDetails().subscribe(
      (data: IPaymentResponse) => {
        if (!data || data === null || data === undefined) {
          this.paymentLoader = false;
          this.payment.status = 'error';
          this.payment.ccAccountHolder = false;
        } else {
          if (data !== undefined && data.NextURL !== undefined && data.NextURL !== '') {
            this.NextURL = this.sanitizer.bypassSecurityTrustResourceUrl(data.NextURL);
            this.paymentLoader = false;
            this.payment.ccAccountHolder = true;
          } else {
            if (data !== undefined && data != null) {
              this.payment.sagepaydown = data.StatusDetail === 'unavailable';
            }
            this.paymentLoader = false;
            this.payment.type = '';
            this.payment.status = 'error';
            this.payment.ccAccountHolder = false;
          }
        }
      }, (error) => {
        this.paymentLoader = false;
        console.error(error);
      } )};  

}
